import React from 'react';
import { motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
export function Hero() {
  return <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-void" data-id="element-322">
      {/* Ambient Orbs - Multi-color */}
      <motion.div animate={{
      y: [0, -40, 0],
      x: [0, 20, 0],
      opacity: [0.2, 0.4, 0.2],
      scale: [1, 1.1, 1]
    }} transition={{
      duration: 8,
      repeat: Infinity,
      ease: 'easeInOut'
    }} className="absolute top-1/4 left-1/4 w-96 h-96 bg-cinema rounded-full blur-[120px] opacity-20 pointer-events-none" data-id="element-323" />
      <motion.div animate={{
      y: [0, 40, 0],
      x: [0, -30, 0],
      opacity: [0.1, 0.3, 0.1],
      scale: [1, 1.2, 1]
    }} transition={{
      duration: 10,
      repeat: Infinity,
      ease: 'easeInOut',
      delay: 1
    }} className="absolute bottom-1/4 right-1/4 w-[30rem] h-[30rem] bg-music rounded-full blur-[150px] opacity-10 pointer-events-none" data-id="element-324" />
      <motion.div animate={{
      scale: [1, 1.05, 1],
      opacity: [0.1, 0.2, 0.1]
    }} transition={{
      duration: 6,
      repeat: Infinity,
      ease: 'easeInOut',
      delay: 2
    }} className="absolute top-1/2 right-1/3 w-64 h-64 bg-relax rounded-full blur-[100px] opacity-10 pointer-events-none" data-id="element-325" />

      <div className="absolute inset-0 film-grain pointer-events-none opacity-50 mix-blend-overlay" data-id="element-326"></div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 text-center flex flex-col items-center mt-16" data-id="element-327">
        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="text-silver tracking-widest uppercase text-sm mb-6" data-id="element-328">
          QUBIX
        </motion.p>

        <motion.h1 initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        delay: 0.4
      }} className="text-display font-serif text-gradient-vibrant leading-tight mb-6 max-w-5xl" data-id="element-329">
          Technology, designed to disappear.
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.6
      }} className="text-subtitle text-platinum max-w-2xl font-light mb-4" data-id="element-330">
          Spaces that respond to you. Sound that surrounds you. Light that
          adapts to you.
        </motion.p>

        <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.8,
        delay: 0.8
      }} className="text-silver text-sm md:text-base max-w-xl font-light italic mb-10" data-id="element-331">
          This is not automation. This is orchestration.
        </motion.p>

        <motion.a href="#experience" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 1
      }} className="relative px-8 py-4 rounded-full text-white text-sm tracking-wide uppercase font-medium group overflow-hidden" data-id="element-332">
          <span className="absolute inset-0 w-full h-full bg-gradient-to-r from-cinema to-music opacity-80 group-hover:opacity-100 transition-opacity duration-300" data-id="element-333"></span>
          <span className="relative z-10" data-id="element-334">Begin Your Experience</span>
        </motion.a>
      </div>

      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      duration: 1,
      delay: 1.5
    }} className="absolute bottom-12 left-1/2 -translate-x-1/2 flex flex-col items-center" data-id="element-335">
        <span className="text-silver text-xs tracking-widest uppercase mb-4" data-id="element-336">
          Explore
        </span>
        <motion.div animate={{
        y: [0, 10, 0]
      }} transition={{
        duration: 2,
        repeat: Infinity,
        ease: 'easeInOut'
      }} data-id="element-337">
          <ChevronDownIcon className="w-6 h-6 text-platinum opacity-50" data-id="element-338" />
        </motion.div>
      </motion.div>
    </section>;
}